export const DYNAMIC_FLAGS_READY_EVENT = 'DYNAMIC_FLAGS_READY';
